/**
 * Pure-frame-jitter rig — minimal render-pipeline surface.
 *
 * Only the Frame Jitter tool window opens; trackers fire normally.
 * Used when investigating render-side performance issues without
 * netcode noise (chat, event rates, reconcile messages) on screen.
 *
 * Pairs with `dj_h2000_capture_telemetry` for bot-driven measurement —
 * fewer overlapping listeners = lower observer-effect floor.
 */

import type { PlaytestRig } from '../environment/devConfig';

export const PURE_FRAME_JITTER_RIG: PlaytestRig = {
  enabled: true,
  label: 'pure-frame-jitter-2026-05-13',
  toolsToOpen: ['frameJitter'],
  enableFrameJitterTracking: true,
  enableReactRenderTracking: true,
  trackerEnableDelayMs: 10000,
};
